// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import StorageListApi from "../../Apis/StorageListApi";

const StorageSelectColdTrace = ({ }) => {

    const [Allergens, setAllergens] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);


    const fetchAllergens = async () => {
        try {
            setLoading(true);
            StorageListApi.ListStorage(page, 20)
                .then((response) => {
                    setTotalPageNew(response.totalPages);
                    setAllergens(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

                    setPage(prevPage => prevPage + 1);
                    setLoading(false);

                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
        if (bottom || nearBottom) {
            if (TotalPageNew > page) {
                fetchAllergens();
            }
        }
    };
    useEffect(() => {
        fetchAllergens();
    }, []);
    return (
        <>
            <Form.Item
                name="storageUnit"
                label="Storage Unit :"
                className="text-lable  disabled"
                rules={[
                    {
                        required: true,
                        message: "Please Select Storage Unit.",
                    },
                ]}
            >
                <Select
                    className="control-Select mb-1"
                    disabled
                    placeholder="Select Storage Unit"
                    onPopupScroll={handleScroll}
                >
                    {Allergens.map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                            {option.name} ({option.temperatureMinInCelsius}'C - {option.temperatureMaxInCelsius}'C)
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>

        </>

    );
};

export default StorageSelectColdTrace;
